/** Internal browser-runtime logging sink. */
const NOOP = () => { };
let injectedLogger = null;
/** Install an application-owned sink for browser runtime diagnostics. */
export function setRuntimeLogger(logger) {
    injectedLogger = logger ?? null;
}
/** Restore the silent browser-runtime default. */
export function resetRuntimeLogger() {
    injectedLogger = null;
}
function resolve(method) {
    const candidate = injectedLogger?.[method];
    return candidate ? candidate.bind(injectedLogger) : NOOP;
}
/** Send an error to the injected browser-runtime sink. */
export function logRuntimeError(...args) {
    resolve('error')(...args);
}
/** Send a warning to the injected browser-runtime sink. */
export function logRuntimeWarn(...args) {
    resolve('warn')(...args);
}
//# sourceMappingURL=runtime-logger.js.map